import ButtonComponent from "@core/helpers/client/components/button";

const Index = ({
	color_type,
	text,
	start_icon,
	end_icon,
	loading,
	variant = "contained",
	direction = 'rtl',
	mode = 'light',
	className,
	badge,
	badge_type = "default",
	disabled,
	tooltip,
	tooltip_placement,
	horizontal_tooltip_placement,
	...props
}) => {
	const default_btn_styles = `flex items-center justify-center transition-all duration-200 text-sm font-bold rounded-md
	cursor-pointer [&>.button-icon]:flex [&>.button-icon]:items-center [&>.button-icon]:transition-all 
	[&>.button-icon]:duration-200 [&>.button-icon>svg]:transition-all 
	[&>.button-icon>svg]:duration-200 [&>.button-text]:flex [&>.button-text]:transition-all [&>.button-text]:duration-200
	
	${loading ? `[&>.button-icon]:w-[18px]! [&>.button-icon]:h-[18px]! [&>.button-text]:w-[18px]! [&>.button-text]:h-[18px]! 
	[&>.button-icon>.spinner]:w-[18px]! [&>.button-icon>.spinner]:h-[18px]! [&>.button-text>.spinner]:w-[18px]! 
	[&>.button-text>.spinner]:h-[18px]! ` : ''}
	
	${((!start_icon && !end_icon) && text) && '[&>.button-text]:py-[1px]'}
	
	${badge || tooltip ? 'relative' : ''}
	`

	const disabled_btn_style = `text-neutral-500 cursor-default! border border-transparent 
	${variant === "contained" ? 'bg-neutral-300' : '[&>.button-icon>svg]:stroke-neutral-500'}`


	const flat_loading_spinner_style = `bg-transparent! border-transparent! shadow-none!
	[&_.spinner]:w-3.5! [&_.spinner]:h-3.5! [&_.spinner]:border-[1.5px]! [&_.spinner]:border-solid!
	[&_.spinner]:border-current! [&_.spinner]:border-b-transparent! [&_.spinner]:bg-transparent!
	[&_.spinner]:opacity-80 cursor-wait`

	const button_style = {
		primary: `${(disabled || loading) ? disabled_btn_style :
			(variant === "contained" ?
				`p-3 gap-1 bg-jmt-neutral-950 text-jmt-text-dark-mode hover:bg-neutral-800 focus:bg-jmt-neutral-950 [&>.button-icon>svg]:stroke-jmt-text-dark-mode`
				:
				'p-3 gap-1 text-jmt-main border border-jmt-neutral-950 [&>.button-icon>svg]:stroke-jmt-main '
			)
			}
			${default_btn_styles}`,

		secondary: `${(disabled || loading) ? disabled_btn_style :
			`p-2 gap-1 bg-jmt-white border border-jmt-neutral-800 text-jmt-neutral-800 hover:bg-jmt-neutral-100
		[&>.button-icon>svg]:stroke-jmt-neutral-800`} ${default_btn_styles}`,

		tertiary: `${(disabled && !loading) ? disabled_btn_style :
			`text-jmt-primary-800 hover:text-jmt-primary-900 text-xs
		[&>.button-icon>svg]:stroke-jmt-primary-900`}
		${loading ? flat_loading_spinner_style : ''} ${default_btn_styles}`,
		flat_design: `flex items-center justify-center gap-1 transition-all duration-200 [&>.button-icon]:transition-all 
		[&>.button-icon]:duration-200 [&>.button-icon>svg]:transition-all [&>.button-icon>svg]:duration-200
		 [&>.button-text]:transition-all [&>.button-text]:duration-200 cursor-pointer
		${disabled ? disabled_btn_style : ''}
		 ${badge || tooltip ? 'relative' : ''}`,

		flat_structure: `transition-all duration-200	[&>.button-icon]:transition-all [&>.button-icon]:duration-200 
		[&>.button-icon>svg]:transition-all [&>.button-icon>svg]:duration-200
		[&>.button-text]:transition-all [&>.button-text]:duration-200 cursor-pointer
		${badge || tooltip ? 'relative' : ''} 
		${disabled ? disabled_btn_style : ''} `
	}

	const default_badge_styles = `absolute -top-2 w-5 h-5 flex items-center justify-center rounded-full 
	text-[11px] pt-[1px] -end-1.5`;

	const badge_styles = {
		default: `${default_badge_styles} ${variant === 'contained' ?
			'text-jmt-primary-800 bg-neutral-100 ring-1 ring-jmt-primary-800' : 'bg-jmt-primary-800 text-white'}`,
		success: `${default_badge_styles} bg-green-500 text-white `,
		danger: `${default_badge_styles} bg-red-500 text-white`,
		warning: `${default_badge_styles} bg-yellow-500 text-white`,
		info: `${default_badge_styles} bg-blue-500 text-white`,
	}

	return (
		<ButtonComponent
			{...({
				...props,
				disabled,
				color_type,
				text,
				start_icon,
				end_icon,
				loading,
				variant,
				direction,
				mode,
				badge,
				badge_type,
				className,
				tooltip,
				tooltip_placement,
				horizontal_tooltip_placement
			})}
			options={{
				btn: button_style,
				badge: badge_styles,
			}}
		/>
	)
}

export default Index